export class MobileHelpers {

	static readonly xsMinWidth = 380;
	static readonly smMinWidth = 576;
	static readonly mdMinWidth = 768;
	static readonly lgMinWidth = 992;
	static readonly xlMinWidth = 1200;
	static readonly xxlMinWidth = 1920;

	public static isBelowMd() : boolean {
		return window.innerWidth < MobileHelpers.mdMinWidth;
	}
}